import { QueryClientProvider } from "@tanstack/react-query";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";

import { initAnalytics } from "@util/analytics";
import { queryClient } from "../../http/query.js";
import Composer from "../composer/index.js";

import ErrorBoundary from "../../components/app/ErrorBoundary.js";
import ComposerStandaloneLayout from "./ComposerStandaloneLayout.js";

import { WebappTrpc } from "@util/trpc/trpcClient";
import "../../index.css";

initAnalytics();

const baseUrl = window.location.origin;

const ComposerStandaloneRoot = () => {
  const history = createBrowserHistory();

  return (
    <Router history={history}>
      <WebappTrpc.trpc.Provider
        client={WebappTrpc.trpcClient}
        queryClient={queryClient}
      >
        <QueryClientProvider client={queryClient}>
          <ComposerStandaloneLayout>
            <ErrorBoundary>
              <Composer baseUrl={baseUrl} isPublic />
            </ErrorBoundary>
          </ComposerStandaloneLayout>
        </QueryClientProvider>
      </WebappTrpc.trpc.Provider>
    </Router>
  );
};

export default ComposerStandaloneRoot;
